<template>
	<div>
		<div class="home" :style="{display: 'grid', 'grid-template-columns': gridTemplate}">
			<Slider v-for="n in config.sliderNumber" :key="n" :id="n" :files="fileChunk(n)" :reverseDirection="n % 2 === 0 ? false : true"/>
		</div>
		<transition name="fade">
			<Galery v-if="galeryOpenend"/>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import Slider from '@/components/Slider.vue'
import Galery from '@/components/Galery.vue'

export default {
	name: 'Home',
	data: () => {
		return {
			files: [],
			slidesNumber: 10
		}
	},
	components: {
		Slider,
		Galery
	},
	created () {
		this.files = require.context('../assets/projects').keys().map(file => file.slice(2))

		for (let i = this.files.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * i)
			const temp = this.files[i]
			this.files[i] = this.files[j]
			this.files[j] = temp
		}
	},
	mounted () {
		this.$store.dispatch('getSettings')
	},
	computed: {
		...mapGetters(['config', 'galeryOpenend']),
		gridTemplate () {
			return `repeat(${this.config.sliderNumber}, 1fr)`
		}
	},
	methods: {
		fileChunk (id) {
			const chunk = (this.files.length / this.config.sliderNumber)
			return this.files.slice((id - 1) * chunk, id * chunk)
		}
	}
}
</script>

<style lang="scss">
</style>
